import { showCustomImage } from 'globalCommon/utils/index';
import { UserLogoMap } from '../../common/utils/imageSource';
import commonPageService from 'pcCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import './style.css';
import video from 'globalCommon/utils/video';

function init() {
    showCustomImage(UserLogoMap, 'customer-img');
    video.init();
    commonPageService({ renderAfter: syncRender });
}

init();
